import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
  dateRequired: {
    description: 'Local Delivery Custom Pickup Date Modal Date Required',
    defaultMessage: 'Date is required',
    id: 'Rs2A4y',
  },
  dateInvalid: {
    description: 'Local Delivery Custom Pickup Date Modal Date Invalid',
    defaultMessage: 'Please set a valid date',
    id: 'hIbQhj',
  },
  timeRequired: {
    description: 'Local Delivery Custom Pickup Date Modal Time Required',
    defaultMessage: 'Time is required',
    id: 'xZrGS1',
  },
});

export const messages = defineMessages({
  modalTitle: {
    description: 'Local Delivery Custom Pickup Date Modal Title',
    defaultMessage: 'Custom Date/Time',
    id: 'TvF5pd',
  },
  dateLabel: {
    description: 'Local Delivery Custom Pickup Date Modal Date Label Text',
    defaultMessage: 'Date',
    id: 'ST99JX',
  },
  dateSubLabel: {
    description: 'Local Delivery Custom Pickup Date Modal Date SubLabel Text',
    defaultMessage: 'You can select any date in the next 7 days.',
    id: 'TZIAPu',
  },
  timeLabel: {
    description: 'Local Delivery Custom Pickup Date Modal Time Label Text',
    defaultMessage: 'Time',
    id: 'idufw3',
  },
  timeSubLabel: {
    description: 'Local Delivery Custom Pickup Date Modal Time SubLabel Text',
    defaultMessage: 'A pickup will be scheduled at this time but may occur later, depending on carrier availability.',
    id: 'HzRwRa',
  },
  save: {
    description: 'Local Delivery Custom Pickup Date Modal Save Button Text',
    defaultMessage: 'Save',
    id: '0nyx7Z',
  },
  cancel: {
    description: 'Local Delivery Custom Pickup Date Modal Cancel Button Text',
    defaultMessage: 'Cancel',
    id: 'kLCVce',
  },
});
